module.exports = __webpack_public_path__ + "img/opdracht-niet-gehaald.b6e12e1d.png";